import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH } from '../constants';

export const MISC_REQUEST_TYPE_OPTIONS = [
  { value: 'SERV', text: 'SERV – Service Coordinator' },
  { value: 'DRUG', text: 'DRUG – Drug Related Expenses' },
  {
    value: 'FORQ',
    text: 'FORQ – Field Office Initiated accounting adjustment',
  },
  { value: 'OARQ', text: 'OARQ – Owner/Agent initiated accounting adjustment' },
  { value: 'RGRC', text: 'RGRC – Retroactive GRC Adjustment' },
  { value: 'UUTL', text: 'UUTL – Unclaimed Utility Check' },
  { value: 'RSPC', text: 'RSPC – Recouped Special Claims Funds' },
  { value: 'CEAD', text: 'CEAD – Contract Expiration Adjustment' },
  { value: 'EIVP', text: 'EIVP – EIV Penalty' },
  { value: 'RESR', text: 'RESR – Residual Receipts' },
  { value: 'INTA', text: 'INTA – Interest adjustment submitted by PBCA' },
];

export const getMiscRequestTypeLabel = (value) => {
  if (!value) return '';
  const match = MISC_REQUEST_TYPE_OPTIONS.find((opt) => opt.value === value);
  return match?.text ?? String(value);
};

export const getMiscAccountingStatusDisplay = (status) => {
  const normalized = String(status || '')
    .toLowerCase()
    .trim();

  if (normalized === 'not_submitted') return 'Not Submitted';
  if (normalized === 'submitted') return 'Submitted';
  if (normalized === 'successful' || normalized === 'success') return 'Success';
  if (normalized === 'error') return 'Error';
  if (normalized) return status;
  return '';
};

export const HEADERS = [
  {
    id: 'requestType',
    label: <FormattedMessage {...messages.miscRequestType} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'comments',
    label: <FormattedMessage {...messages.comments} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    defaultWidth: 300,
  },
  {
    id: 'requestedAmount',
    label: <FormattedMessage {...messages.requestedAmount} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'approvedAmount',
    label: <FormattedMessage {...messages.approvedAmount} />,
    dataType: 'number',
    defaultWidth: DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH,
    sortable: true,
    searchable: true,
  },
  {
    id: 'chargeCode',
    label: <FormattedMessage {...messages.chargeCode} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'actions',
    label: <FormattedMessage {...messages.actions} />,
    defaultWidth: 75,
  },
];

export const PROPERTY_PATH_MAP = {
  requestType: {
    path: 'requestTypeDisplay',
    dataType: 'string',
  },
  comments: {
    path: 'comments',
    dataType: 'string',
  },
  requestedAmount: {
    path: 'requestedAmount',
    dataType: 'number',
  },
  approvedAmount: {
    path: 'approvedAmount',
    dataType: 'number',
  },
  chargeCode: {
    path: 'chargeCode',
    dataType: 'string',
  },
  actions: {
    path: 'actions',
    dataType: 'string',
  },
};
